import React from 'react';
import '../assets/css/styles.css';
import "../assets/css/AboutUs.css";
import "../assets/css/OurCSR.css"
import HighlightsCarousel from '../components/HighlightsCarousel';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext
import { useContext } from 'react';
import { t } from 'i18next';

// ========================= AboutUs.jsx =========================

/* ----------------------------------------------------------------
 *  HeroSection – full‑width banner with strong headline & sub‑title
 * ----------------------------------------------------------------*/
const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const IntroSection = () => {
  const { t } = useContext(LanguageContext); 
  return (
//   <header className="intro">
    <div className="intro-overlay">
      <p> {t.csr_description_p_1} <br /> <br />
        {t.csr_description_p_2} 
      </p>
    </div>
//   </header>
);
}

/* ----------------------------------------------------------------
 *  MissionVision – company mission & vision side‑by‑side
 * ----------------------------------------------------------------*/
const MissionVision = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
  <section className="mission-vision container">
      <div className="mission card">
        <h2>{t.our_esg_commitment}</h2>
        <p>
          {t.our_esg_description}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.env_sustainability}</h2>
        <p>
          {t.env_sustainability_description}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.community_development}</h2>
        <p>
          {t.community_development_description}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.our_people}</h2>
        <p>
          {t.our_people_description}
        </p>
      </div>
    </section>
  );
}

/* ----------------------------------------------------------------
 *  TeamSection – responsive grid of key team members
 * ----------------------------------------------------------------*/
const teamData = [
  { name: "Makarios Mbundoh Akembuom", title: "Chief Executive Officer", img: "" },
  { name: "Lufong George Yuven", title: "HSO (Head of Strategic Operations)", img: "" },
  { name: "Nsonagai Paul Mbeh", title: "Operations Manager", img: "" },
];

const TeamSection = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
    <section className="team container">
      <h2 className="section-title">{t.our_executive_team}</h2>
      <p>{t.team_description}</p>
      <div className="team-grid">
        {teamData.map((member) => (
          <article className="team-card" key={member.name}>
            <img src={member.img} alt={member.name} className="team-photo" />
            <h3>{member.name}</h3>
            <p>{member.title}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

const ExpertSection = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
    <section className="team container">
      <h2 className="section-title">{t.get_involved}</h2>
      <div className="get-involved">
        <p>
          {t.get_involved_description}
        </p>
      </div>
    </section>
  );
}


/* ----------------------------------------------------------------
 *  AboutUs – page wrapper exporting all blocks
 * ----------------------------------------------------------------*/
export default function AboutUs() {
const { t } = useContext(LanguageContext); // Access translations
  return (
    <>
    <HeroSection
    title={t.our_csr_title}
    subtitle=""
    />
    <IntroSection />
    <MissionVision />
    <TeamSection />
    <ExpertSection />
    <div className="news-section">
        <p>{t.our_blog}</p>
        <h2>
            <span className="highlight">{t.news_section_highlight} </span>{t.news_section_opening}
        </h2>
        <p className="opening">{t.news_section_description}</p>
        <HighlightsCarousel />
    </div>
    </>
  );
}